/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Tab_BillingInputs */

const en_client_tab_billing = /** @type {(inputs: Client_Tab_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const pl_client_tab_billing = /** @type {(inputs: Client_Tab_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozliczenia`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Client_Tab_BillingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const client_tab_billing = /** @type {((inputs?: Client_Tab_BillingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Tab_BillingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_client_tab_billing(inputs)
	return en_client_tab_billing(inputs)
});